import axiosHttp from "./interceptor.service";

const postEmployee = (data) => {
  return axiosHttp.post("/lmt/employee", data);
};

const getEmployee = (data) => {
  return axiosHttp.get("/lmt/getEmployee", data);
};

const getEmployeeQualification = (data) => {
  return axiosHttp.get("/lmt/getQualification", data);
};

const getEmployeeDepartment = (data) => {
  return axiosHttp.get("/lmt/getAllDepartment", data);
};

const getEmployeeRole = ({ id } = {}) => {
  return axiosHttp.get("/lmt/getRole", { params: { id } });
};

const getEmployeeStatus = (data) => {
  return axiosHttp.get("/lmt/getAllStatus", data);
};

const getEmployeeType = (data) => {
  return axiosHttp.get("/lmt/getAllType", data);
};
export {
  postEmployee,
  getEmployee,
  getEmployeeQualification,
  getEmployeeDepartment,
  getEmployeeRole,
  getEmployeeStatus,
  getEmployeeType,
};
